module.exports = __webpack_public_path__ + "static/media/opt_in-out.3d3e9207.svg";